<script lang="ts">
    import {onMount} from "svelte";
    import TabContentView from "../../../../../component/common/Tab/TabContentView.svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import TipsMessageAreaView from "../../../../../component/common/Message/TipsMessageAreaView.svelte";
    import {BinaryTable} from "../../../../../lib/Table/BinaryTable";

    export let activeTabName;

    $: baseUrl = (() => {
        const baseUrl = window.location.origin;
        const uploadApiUrl = baseUrl + UrlUtil.createApiUrl(`/binary/access_token`);
        return uploadApiUrl;
    })();

    onMount(() => {
    });


</script>

<TabContentView tabName="アップロード" activeTabName={activeTabName}>
    <div class="binary-api-help-upload-tab-content">
        <div>
            スペース全体のアクセストークンを使うか、アプリごとのアクセストークンを使うか、二通りの指定方法があります。
            <br/>
            必須ではないですが、jqコマンドをパイプで重ねがけしておくと、返ってくるjsonが見やすく整形されます。
        </div>
        <div>
            <fieldset>
                <legend>アプリアクセストークン</legend>
                <div>
                    対象アプリのみのファイルをアップロードできる
                </div>

                <div class="curl-command-area">
                    <fieldset>
                        <legend>curlコマンド例</legend>
                        <div class="curl-command">
                            curl --fail-with-body -X POST "{ baseUrl }" -F "app_access_token=[アプリアクセストークン]" -F
                            "name=[バイナリバージョン名]"
                            -F
                            "platform_type_name=[プラットフォームタイプ名]"
                            -F
                            "redirect_key=[リダイレクトキー]" -F
                            file=@"[ファイルパス]"
                        </div>
                        上記に加え、最後に任意ですが
                        <div class="curl-command">
                            | jq
                        </div>
                        を加えると jsonレスポンスが見やすく整形されます。
                    </fieldset>
                </div>

                <TipsMessageAreaView>
                    アプリアクセストークンは、バイナリ画面にて、管理者のみ登録できます。
                </TipsMessageAreaView>

            </fieldset>
        </div>

        <div>
            <fieldset>
                <legend>スペースアクセストークン</legend>
                <div>
                    スペース全体の中で選んだバイナリのファイルをアップロードできる
                </div>

                <div class="curl-command-area">
                    <fieldset>
                        <legend>curlコマンド例</legend>
                        <div class="curl-command">
                            curl --fail-with-body -X POST "{ baseUrl }" -F "space_access_token=[スペースアクセストークン]" -F
                            "app_unique_id=[アプリユニークID]" -F
                            "name=[バイナリバージョン名]"
                            -F
                            "platform_type_name=[プラットフォームタイプ名]"
                            -F
                            "redirect_key=[リダイレクトキー]" -F
                            file=@"[ファイルパス]"
                        </div>
                        上記に加え、最後に任意ですが
                        <div class="curl-command">
                            | jq
                        </div>
                        を加えると jsonレスポンスが見やすく整形されます。
                    </fieldset>
                </div>

                <TipsMessageAreaView>
                    スペースアクセストークンは、バイナリ画面にて、管理者のみ登録できます。
                    アプリユニークIDは、バイナリ画面に表示されているユニークIDです。
                </TipsMessageAreaView>

            </fieldset>
        </div>


        <div>
            <fieldset>
                <legend>共通パラメーター</legend>
                <div class="param-area">
                    <table>
                        <thead>
                        <tr>
                            <th>key</th>
                            <th>説明</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>file</td>
                            <td>アップロードする apk or ipa or exe を指定してください</td>
                        </tr>
                        <tr>
                            <td>platform_type_name</td>
                            <td>
                                <div>アップロードするプラットフォームタイプ名を指定してください</div>
                                <div>android or ios or gpg or dmm を指定してください。いずれも小文字。</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>name</div>
                            </td>
                            <td>バイナリ名を指定できます。指定しなければファイル名が自動設定されます</td>
                        </tr>
                        <tr>
                            <td>
                                <div>redirect_key (任意)</div>
                            </td>
                            <td>
                                <div>
                                    設定時にスペースごとにプレフィックスをつけてください。全体で重複するとエラーになります。
                                </div>
                                <div>
                                    指定しておくと、対象アプリのページへリダイレクトしてくれるURLが発行されます。
                                </div>
                                <div>
                                    設定済の場合は、 binary_redirect_url が返ってきます。
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>description (任意)</div>
                            </td>
                            <td>
                                <div>
                                    指定しておくと、説明が追加できます。バイナリファイルの説明や更新内容を入れておくことができます。
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>version (任意)</div>
                            </td>
                            <td>
                                <div>
                                    指定しておくと、version が設定できます。アセットバンドルの際に Resource
                                    のバージョンを入れておくとどのアセットバンドルのバージョンなのかを明示的に設定しておけます。
                                </div>
                                <div>
                                    apk, ipa の場合は、設定非推奨で、バイナリのバージョン情報が自動的に設定されるため、APIで指定する必要はありません。
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>tag_names (任意)</div>
                            </td>

                            <td>
                                <div>タグの登録ができます。</div>
                                <div>1つのタグだけでもいいし、スペース(半角or全角)区切りすると複数のタグを一気に登録できます。</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>app_version_count (任意)</div>
                            </td>
                            <td>
                                <div>
                                    指定しておくと、アプリのバージョンカウントを上書きできます。
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>ci_job_url (任意)</div>
                            </td>
                            <td>
                                <div>
                                    指定しておくと、Jenkins などの CI の Job URLが表示されます。
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>slack_additional_text (任意)</div>
                            </td>
                            <td>
                                <div>
                                    指定しておくと、Slack通知時にメッセージが追加できます。
                                </div>
                                <div>
                                    更に追加テキストの中に #pj-ready-notice のように #
                                    から始まるSlackチャンネル名を入れると、そのチャンネルにも通知が追加で行われます。
                                </div>
                                <div>
                                    追加通知チャンネルは基本的に何個でも指定可能です。
                                </div>
                                <div>
                                    ※ 注意点として、チャンネル名の対応表は深夜に更新しているため、作成したばかりのチャンネルの場合は通知がされないことがあります。1日お待ち下さい。
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <div>status (任意)</div>
                            </td>
                            <td>
                                <div>
                                    一部のステータスに更新できます。
                                </div>
                                <div>
                                    値としては、 cancel or building or build_error が指定可能です
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>id (任意)</div>
                            </td>
                            <td>
                                <div>
                                    id を指定しなければ、バイナリ新規登録。指定すれば更新になります。
                                </div>
                                <div>
                                    ※ もちろんどのバイナリでも更新できるわけではなく、指定したアプリ以下のバイナリのみ更新可能です。
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>type_name (任意)</td>
                            <td>
                                <div>指定するとインストールするアプリ以外がアップロードできます</div>
                                <div>unity_asset_bundle が指定できます。小文字。zip のみアップロードが可能になります。</div>
                                <div>インストールするファイルではなく、タグ付けしてバイナリと紐づけしたファイルをアップロードしてください</div>
                            </td>
                        </tr>
                        <tr>
                            <td>auto_delete_type (任意)</td>
                            <td>
                                <div>バイナリ自動削除の時のタイプを設定できます。()内の数値を value として設定してください</div>
                                {#each Object.entries(BinaryTable.AutoDeleteType.map) as [id, name] }
                                    <div>
                                        { BinaryTable.AutoDeleteType.getDescription(id, true) }
                                    </div>
                                {/each}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <TipsMessageAreaView>
                        ・file, platform_type を指定してアップロードすると、新規アップロードになります。
                        ・file を指定しない場合は、空ファイルとしてアップロードされます
                        ・id を指定すると既存バイナリの更新になります
                    </TipsMessageAreaView>
                </div>
            </fieldset>

        </div>

        <fieldset>
            <legend>レスポンス(抜粋)</legend>
            <div class="response-area">
                <table>
                    <thead>
                    <tr>
                        <th>key</th>
                        <th>説明</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>binary_id</td>
                        <td>バイナリに自動で設定されたID</td>
                    </tr>
                    <tr>
                        <td>binary_url</td>
                        <td>認証が必要なバイナリを管理するページのURL</td>
                    </tr>
                    <tr>
                        <td>binary_redirect_url</td>
                        <td>
                            <div>
                                事前に指定した download_key を使ってバイナリ詳細に飛べるURL
                            </div>
                            <div>
                                { location.origin + `/api/binary/redirect/[redirect_key]` }
                                というURLが返ってくるので、redirect_key さえあればURLは組み立て可能です。
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </fieldset>

    </div>


</TabContentView>
<style lang="scss">
    .binary-api-help-upload-tab-content {
        display: flex;
        flex-direction: column;
        gap: 32px;
        font-size: 0.75em;

        padding: 16px;

        .curl-command-area {
            .curl-command {
                white-space: normal;

                background-color: #000;
                color: #fff;
                padding: 0.5em;

            }
        }
    }
</style>